<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="datetimerange"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <input-search placeholder="住户名称/房间号/人员姓名" @search="searchKey" />
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import api from "../../api/LadderControl";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    TableMain,
    InputSearch,
    Breadcrumb
  },
  name: "identification-record",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧梯控",
          name: "ladder-device"
        },
        {
          value: "识别记录"
        }
      ],
      tableHead: [
        {
          prop: "enterpriseName",
          label: "住户名称"
        },
        {
          prop: "roomInfoNumber",
          label: "房间号"
        },
        {
          prop: "personName",
          label: "人员姓名"
        },
        {
          prop: "deviceName",
          label: "梯控设备"
        },
        {
          prop: "liftDeviceName",
          label: "电梯名称"
        },
        {
          prop: "openTypeText",
          label: "识别类型"
        },
        {
          prop: "openTime",
          label: "进出时间"
        },
        {
          prop: "snapUrl",
          label: "人脸照片",
          isLookOver: true
        }
      ],
      tableData: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      total: 0,
      pageSize: 10,
      pageNum: 1,
      timeValue: [],
      requestData: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        searchKey: ""
      }
    };
  },
  created() {
    // this.getPage()
    this.getCreatTime();
  },
  activated() {
    this.getCreatTime();
  },
  methods: {
    getCreatTime() {
      this.timeValue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timeValue[0] = `${year}-${month}-${date} 00:00:00`;
      this.timeValue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue.length > 0) {
        reqData.startTime = `${this.timeValue[0]}`;
        reqData.endTime = `${this.timeValue[1]}`;
      }
      api.getLiftRecordPage(reqData).then(data => {
        this.total = data.total;
        let list = data.list;
        list.map(v => {
          if (v.openType === "1") {
            v.openTypeText = "二维码";
          } else if (v.openType === "2") {
            v.openTypeText = "密码";
          } else if (v.openType === "3") {
            v.openTypeText = "按钮";
          } else if (v.openType === "4") {
            v.openTypeText = "刷卡";
          } else if (v.openType === "5") {
            v.openTypeText = "人脸";
          }
          v.picUrl = v.visitorPicSnapUrl;
        });
        this.tableData = list;
      });
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeTimeValue() {}
  },
  watch: {
    timeValue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>
<style lang="less">
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/IdentificationRecord/IdentificationRecord.vue